import React, { useState } from 'react';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../store/auth-context';
import AdminNavbar from './AdminNavbar';
import AdminUserContent from './AdminUserContent';
import AdminExperience from './Experience/AdminExperience';
import AdminProjects from './Projects/AdminProjects';

const AdminSection = () => {
  const context = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('user');

  const activeTabHandler = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      {context.isLoggedIn && (
        <div className='admin-section'>
          <AdminNavbar
            activeTabHandler={activeTabHandler}
            activeTab={activeTab}
          />

          <div className='admin-section-content'>
            {activeTab === 'user' && (
              <AdminUserContent
              // userDataHandler={userDataHandler}
              // userDetails={userDetails}
              />
            )}

            {activeTab === 'projects' && <AdminProjects />}

            {activeTab === 'experience' && <AdminExperience />}
          </div>
        </div>
      )}
      {!context.isLoggedIn && <Navigate to='/' />}
    </>
  );
};
export default AdminSection;
